import { InjectionToken } from '@angular/core';

export const IS_BOTTOM_SHEET = new InjectionToken<boolean>('IS_BOTTOM_SHEET', {
  factory: () => false,
});
